import Const from './const'
import * as Data from './data'
import Api from './api/index'
import * as Util from './utils'

let Core = {
    Const,
    Data,
    Api,
    Util
}

export default Core